import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "../components/Reveal";
import { BookDemoButton } from "../components/BookDemoButton";
import { FullLogo } from "../components/Logo";

const EASE = [0.16, 1, 0.3, 1];

export const FinalCTA = () => {
  return (
    <section
      id="final"
      className="relative flex flex-col items-center overflow-hidden px-6 pt-6 pb-10 text-center md:pt-8"
    >
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[620px] w-[620px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-25 blur-[140px]"
        style={{ background: "radial-gradient(closest-side, rgba(234,106,67,0.4), transparent)" }}
      />

      <Reveal className="relative flex flex-col items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.94 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: EASE }}
        >
          <FullLogo className="w-[350px] sm:w-[440px]" />
        </motion.div>

        <h2 className="mt-8 max-w-5xl font-display text-6xl font-black leading-[0.9] tracking-tighter text-[#1b1a18] sm:text-7xl lg:text-[6.5vw]">
          One Kitchen. One System.
          <br />
          <span className="text-[#EA6A43]">One Way to Work.</span>
        </h2>

        <div className="mt-10">
          <BookDemoButton size="lg" testId="final-book-demo" />
        </div>
      </Reveal>
    </section>
  );
};
